import { useAddNativeClasses } from '@carvana/merch-native/hooks';
import { useContext } from 'react';
import { legacySizes } from '~/constants/common/resizeBreakpoints';
import { useNativeDeviceType } from '~/context/common/DeviceContext';
import {
  useUserId,
  useIsLoggedIn,
  useUserLocation
} from '~/context/common/UserContext';
import ModalContext from '~/context/vdp/ModalContext';
import { useResizeListener, useTrackClickEvents } from '~/hooks/common';
import { useTrackCreditKarmaPromo } from '~/hooks/common/creditKarmaPromo';
import { useGetDiscountData } from '~/hooks/common/services';
import useDataDogRUM from '~/hooks/common/useDataDogRUM';
import useGetTrades from '~/hooks/common/useGetTrades';
import useModalScrollRestoration from '~/hooks/common/useModalScrollRestoration';
import useSynchronizeAuth from '~/hooks/common/useSynchronizeAuth';
import { useGetFavorites } from '~/hooks/vdp/favorites';
import useGetDeliveryPickup from '~/hooks/vdp/services/useGetDeliveryPickup';
import useGetRecalls from '~/hooks/vdp/services/useGetRecalls';
import useGetTransitRoute from '~/hooks/vdp/services/useGetTransitRoute';
import useGetUserFinancing from '~/hooks/vdp/services/useGetUserFinancing';
import useGetUserPurchasing from '~/hooks/vdp/services/useGetUserPurchasing';
import useGetVehicleAvailability from '~/hooks/vdp/services/useGetVehicleAvailability';
import useGetVehicleRating from '~/hooks/vdp/services/useGetVehicleRating';
import {
  useNativeMessageDispatcher,
  useNativeMessageListener
} from '~/native/vdp';
import {
  useEventDispatchers,
  useEventListeners,
  useGeolocation,
  usePageHash,
  usePageHeaderLoaded,
  useSendDataEvents
} from './hooks';
import useSendSoftNotify from './hooks/events/useSendSoftNotify';
import useHeroViewedEvent from '../Hero/useHeroViewedEvent';

export default function VehicleDetailsData() {
  const { isAnyModalOpen } = useContext(ModalContext);
  const nativeDeviceType = useNativeDeviceType();
  const { state: stateAbbreviation } = useUserLocation();
  const isLoggedIn = useIsLoggedIn();
  const userId = useUserId();

  useDataDogRUM();
  useHeroViewedEvent();
  useSynchronizeAuth();
  usePageHash();
  usePageHeaderLoaded();
  useSendDataEvents();
  useSendSoftNotify();
  useTrackClickEvents();
  useResizeListener(legacySizes);

  useEventDispatchers();
  useEventListeners();
  useNativeMessageDispatcher();
  useNativeMessageListener();
  useAddNativeClasses(nativeDeviceType.isNative, nativeDeviceType.platform);

  useGetDiscountData({ shouldFetch: true, stateAbbreviation, userId });
  useGeolocation(isLoggedIn);
  useModalScrollRestoration(isAnyModalOpen);
  useGetFavorites();
  useGetTrades(isLoggedIn);
  useGetDeliveryPickup();
  useGetRecalls();
  useGetUserFinancing();
  useGetVehicleAvailability();
  useGetTransitRoute();
  useGetUserPurchasing();
  useGetVehicleRating();
  useTrackCreditKarmaPromo();

  return null;
}
